import type { FC, ReactNode } from 'react'
import type { GetStaticProps } from 'next'
import type { HomeContent, SiteContent } from '@/types'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import About from '@/components/landing/about'
import Countdown from '@/components/landing/countdown'
import Hero from '@/components/landing/hero'
import OrderSection from '@/components/landing/order-section'
import Quotes from '@/components/landing/quotes'
import { getHomeContent, getSiteContent } from '@/lib/content'

interface HomeProps extends HomeContent {
    site: SiteContent
}

const Home: FC<HomeProps> = ({
    site,
    packages,
    deliveryTiers,
    cities,
    quotes
}): ReactNode => {
    return (
        <Layout>
            <Seo description={site.settings.site_description ?? undefined} />

            <Hero />
            <Countdown />
            <About packages={packages} />
            <OrderSection packages={packages} deliveryTiers={deliveryTiers} cities={cities} />
            <Quotes quotes={quotes} />
        </Layout>
    )
}

export const getStaticProps: GetStaticProps<HomeProps> = async () => {
    const [site, home] = await Promise.all([getSiteContent(), getHomeContent()])

    return {
        props: { site, ...home },
        revalidate: 60
    }
}

export default Home
